import React from "react";
import {IHubArgs} from "../../HubFramework/IHub";

export type DamsDataContextValue = {
    hubArgs?: IHubArgs;
};

const defaultValue: DamsDataContextValue = {
    hubArgs: undefined,
};

export const DamsDataContext = React.createContext<DamsDataContextValue>(defaultValue);

export const useDamsData = () => React.useContext(DamsDataContext);
